import type { DehydratedState } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { QueryClientCustomProvider } from 'src/components/common/QueryClient';
import { IntlProvider } from '@features/intl';
import {
  AnalyticsDebuggerProvider,
  AnalyticsInject,
} from '@features/Analytics';
import { ThemeProvider } from '@features/Theme';
import { RootStoreProvider } from '@components/common/root-store-provider/root-store-provider';
import { FeatureFlagProvider } from '@features/FeatureToggle';
import { ErrorBoundary } from 'src/components/common/ErrorBoundary';
import { LegendStateProvider } from 'src/stores/legend';

export const Providers = ({
  children,
  dehydratedState,
}: { children: ReactNode; dehydratedState: DehydratedState }) => (
  <IntlProvider>
    <QueryClientCustomProvider dehydratedState={dehydratedState}>
      <ErrorBoundary>
        <RootStoreProvider>
          <LegendStateProvider>
            <FeatureFlagProvider>
              <AnalyticsDebuggerProvider>
                <ThemeProvider>
                  {children}
                  <AnalyticsInject />
                </ThemeProvider>
              </AnalyticsDebuggerProvider>
            </FeatureFlagProvider>
          </LegendStateProvider>
        </RootStoreProvider>
      </ErrorBoundary>
    </QueryClientCustomProvider>
  </IntlProvider>
);
